import { Directive, Input, TemplateRef, ViewContainerRef, inject } from "@angular/core";
import { CdkPortal } from "@angular/cdk/portal";

@Directive({ selector: "[inlineColumnTemplate]ng-template" })
export class InlineColumnTemplateDirective extends CdkPortal {
   @Input() public inlineColumnTemplate!: string;

   constructor() {
      const templateRef = inject<TemplateRef<any>>(TemplateRef);
      const viewContainerRef = inject(ViewContainerRef);

      super(templateRef, viewContainerRef);
   }
}
